import config from "@/config"
import http from "@/utils/request"
export default {
	import: {
		url: `${config.API_URL}/orders/upload/fba/order?operate_kind=1`,
		name: "FBA导入",
		post: async function (data) {
			if (data.sell_product_id) {
				this.url = `${config.API_URL}/orders/upload/fba/order?operate_kind=1
				&href=${data.href}&sell_product_id=${data.sell_product_id}`
			} else {
				this.url = `${config.API_URL}/orders/upload/fba/order?operate_kind=1&href=${data.href}`
			}
			return await http.post(this.url, data.formData);
		}
	}
}
